import React, { Fragment, useContext } from 'react';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

import { createStyles } from '../../../../utils/createStyle';

import { monetizeWithDecimal } from 'common/utils/strings';
import { RadioItem } from 'features/product/components/RadioItem';
import { OrderScreenContext } from 'features/order-summary/screens/CheckoutScreen';

const styles = createStyles({
    grid: [
        'grid w-full',
        {
            gridTemplateColumns: 'auto auto 100px',
        },
    ],
    shippingMethodCols: [
        'border-b border-solid border-grey-3 text-grey-2 py-1',
        { backgroundColor: '#F7F7F7', fontSize: '10px' },
    ],
    cell: [
        'text-sm',
        {
            marginBottom: '23px',
        },
    ],
});

export const OrderShippingGrid = () => {
    const { cartInfo, setCartInfo, cartInfoDetails } = useContext(OrderScreenContext);

    const shippingOptions = cartInfoDetails.shippingOptions;

    const formatEstimatedShipDate = (name: string) => {
        const estimated = cartInfoDetails.estimationResponses[name];
        const today = new Date(new Date().toDateString());

        if (estimated && estimated.data) {
            const fixEstimatedDate = estimated.data.estimatedShipDate.endsWith('Z')
                ? estimated.data.estimatedShipDate.substring(
                      0,
                      estimated.data.estimatedShipDate.length - 1
                  )
                : estimated.data.estimatedShipDate;
            const deliveryDate = new Date(fixEstimatedDate).getTime();
            const days = (deliveryDate - today.getTime()) / (1000 * 3600 * 24);
            return `Ships within ${days} day${days > 1 ? 's' : ''}`;
        }

        return '';
    };

    const setShippingMethodId = (shippingMethodId: string) => {
        setCartInfo({
            ...cartInfo,
            shippingMethodId,
        });
    };

    const isLoading =
        cartInfoDetails.isLoadingShipDateEstimations || cartInfoDetails.shipping.isLoading;

    return (
        <div>
            {isLoading && (
                <div>
                    <Skeleton count={5} height={42} />
                </div>
            )}
            {!isLoading && (
                <div>
                    <div className={styles.grid}>
                        <div className={classNames(styles.shippingMethodCols, 'pl-7')}>
                            Shipping Method
                        </div>
                        <div className={styles.shippingMethodCols}>Estimated Shipping Date</div>
                        <div className={classNames(styles.shippingMethodCols, 'text-center')}>
                            Cost
                        </div>
                        <div className="py-1 col-span-3" />
                        {shippingOptions.map((option) => (
                            <Fragment key={option.id}>
                                <div className={classNames(styles.cell, 'text-left pl-2')}>
                                    <RadioItem
                                        selected={cartInfo.shippingMethodId === option.id}
                                        value={option.id}
                                        text={option.name}
                                        onClick={() => setShippingMethodId(option.id)}
                                    />
                                </div>
                                <div className={classNames(styles.cell, 'text-left')}>
                                    {formatEstimatedShipDate(option.name)}
                                </div>
                                <div className={classNames(styles.cell, 'text-center')}>
                                    {monetizeWithDecimal(option.cost)}
                                </div>
                            </Fragment>
                        ))}
                    </div>
                    {shippingOptions.length > 0 && (
                        <div>
                            <ul className="list-disc ml-6 text-xs text-grey-2">
                                <li>Holidays may affect actual ship dates</li>
                                <li>Tracking number not provided with Standard USPS Mail</li>
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
